<button id="loginBtn" class="btn btn-primary" [hidden]="isUserAuthenticated | async" (click)="doAuthorization()">Connect
    Linkedin</button>